<template>
    <div class="details-order">
        <b-container>
            <b-row>
                <router-link :to="{ name: 'FormPage'}" class="btn-back"> Volver</router-link>
                <b-col cols="12" class="mb-4">
                    <h3><img class="icon" src="../../assets/imgs/icn_orderdetails.svg" alt=""> Detalles de la orden</h3>   
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Hospital</span>
                    <p>{{data.hospital}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>No. Colaborador</span>
                    <p>{{data.colaborator}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Sub Configuración de Puesto</span>
                    <p>{{data.area.name}}</p>
                </b-col>
                <b-col md="4" class="mb-4">
                    <span>Puesto</span>
                    <p>{{data.jobPosition}}</p>
                </b-col>
                <!-- <b-col v-if="this.data.area=='Dirección Médica' || this.data.area=='7 Dirección Médica DAMA' || this.data.area=='8 Dirección Médica CABALLERO' " md="4" class="mb-4">
                    <span>Especialidad</span>
                    <p>{{data.speciality}}</p>
                </b-col> -->
                <!-- <b-col v-if="this.data.area=='Dirección Médica' || this.data.area=='7 Dirección Médica DAMA' || this.data.area=='8 Dirección Médica CABALLERO' " md="4" class="mb-4">
                    <span>Bordado</span>
                    <p>{{data.embroidery}}</p>
                </b-col> -->
            </b-row>
            <b-row>
                <b-col cols="12" class="mb-4">
                    <table class="table b-table">
                        <thead role="rowgroup">
                            <tr>
                                <th>
                                    Uniforme
                                </th>
                                <th>
                                    Modelo
                                </th>
                                <th>
                                    Color
                                </th>
                                <th>
                                    Género
                                </th>
                                <th>
                                    Talla
                                </th>
                            </tr>
                        </thead>
                        <tbody role="rowgroup">
                            <tr role="row" v-if="this.data.scrubQty && this.data.modelScrub">
                                <td>
                                    Coordinado Filipina
                                </td>
                                <td>Modelo {{data.modelScrub}}</td>
                                <td>{{data.colorScrub}}</td>
                                <td class="text-center">{{data.gender}}</td>
                                <td class="text-center">{{data.scrub}}</td>
                            </tr>
                            <tr role="row" v-if="this.data.pantsQty && this.data.modelPants">
                                <td>
                                    Coordinado Pantalón
                                </td>
                                <td>Modelo {{data.modelPants}}</td>
                                <td>{{data.colorPants}}</td>
                                <td class="text-center">{{data.gender}}</td>
                                <td class="text-center">{{data.pants}}</td>
                            </tr>
                            <tr role="row" v-if="this.data.overolQty && this.data.modelOverol">
                                <td>
                                    Overol
                                </td>
                                <td>Modelo {{data.modelOverol}}</td>
                                <td>{{data.coloroverol}}</td>
                                <td class="text-center">{{data.gender}}</td>
                                <td class="text-center">{{data.overol}}</td>
                            </tr>
                            <tr role="row" v-if="this.data.shoesQty && this.data.modelShoes">
                                <td>
                                    Calzado
                                </td>
                                <td>Modelo {{data.modelShoes}}</td>
                                <td>{{data.colorshoes}}</td>
                                <td class="text-center">{{data.gender}}</td>
                                <td class="text-center">{{data.shoes}}</td>
                            </tr>
                            <tr role="row" v-for="(item, id) in this.data.coat" :key="id">
                                <td v-if="data.modelCoat[id]">
                                    Bata
                                </td>
                                <td v-if="data.modelCoat[id]">Modelo {{data.modelCoat[id]}}</td>
                                <td v-if="data.modelCoat[id]">{{data.coat[id].color}}</td>
                                <td v-if="data.modelCoat[id]" class="text-center">{{data.gender}}</td>
                                <td v-if="data.modelCoat[id]" class="text-center">{{data.coat[id].size}}</td>
                            </tr>
                            <tr role="row" v-if="this.data.scrubCapQty && this.data.modelScrubCap">
                                <td>
                                    Chamarras
                                </td>
                                <td>Modelo {{data.modelScrubCap}}</td>
                                <td>{{data.colorScrubCap}}</td>
                                <td class="text-center">{{data.gender}}</td>
                                <td class="text-center">{{data.scrubCap}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-col>
                <b-col cols="12" class="mb-4">
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="status"
                        name="checkbox-1"
                        class="mt-2"
                        >
                        Al marcar este checkbox, autorizo la descarga del PDF de la orden y declaro que los datos ingresados son verídicos y han sido revisados a mi conformidad.
                        </b-form-checkbox>
                </b-col>
                <b-col md="6">
                    <b-button v-on:click.once="submitOrder">
                        <div v-if="!loading">Enviar orden</div>
                        <b-spinner v-else variant="light"></b-spinner>
                    </b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import axios from 'axios'
    import qs from 'qs'

    export default {
        props: {
            data: {
                type: Array,
                required: true
            },
        },
        created() {
            var datalist = sessionStorage.getItem('dataUser');
            if (!this.data) {
                this.data = JSON.parse(datalist)
            }
            if (!this.data){
                this.$router.push('/orden')
            }
        },
        data() {
            return {
                status: '',
                loading: false,
                empty: false
            }
        },
        methods: {
            downloadPDF(orderId) {
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                axios.post(
                    'https://api-starmedica.domikuniformes.com/orders_api.php',
                    qs.stringify({
                        api_token: token, 
                        user_id: id_user,
                        option: 'create_pdf',
                        order_id: orderId
                    }),
                    {
                        responseType: 'blob'
                    }
                )
                .then((response) => {

                    const blob = new Blob([response.data], { type: 'application/pdf' })
                    const link = document.createElement('a')

                    link.href = window.URL.createObjectURL(blob)
                    link.download = `orden_${orderId}.pdf`
                    link.click()

                })
                .catch((error) => {
                    console.error(error)
                })

            },
            submitOrder() {
                var token = sessionStorage.getItem('api_token')
                var id_user = sessionStorage.getItem('id_user')
                this.loading = true
                if(this.status){
                    axios
                    .post(
                        'https://api-starmedica.domikuniformes.com/orders_api.php',
                        qs.stringify({ 
                            api_token: token, 
                            user_id: id_user,
                            option: 'new_order',
                            hospital_name: this.data.hospital.toString(),
                            collaborator_number: this.data.colaborator,
                            area_name: this.data.area.name,
                            area_id: this.data.area.id,
                            order_name: this.data.name,
                            order_firstLastname: this.data.lastname1,
                            order_secondLastname: this.data.lastname2,
                            order_speciality: this.data.speciality,
                            order_embroid: this.data.embroidery,
                            order_gender: this.data.gender,
                            order_phone: this.data.phone,
                            order_mail: this.data.email,
                            order_scrubSize: this.data.scrub,
                            order_scrubQty: this.data.scrubQty,
                            order_pantsSize: this.data.pants,
                            order_pantsQty: this.data.pantsQty,
                            order_overolSize: this.data.overol,
                            order_overolQty: this.data.overolQty,
                            order_shoesSize: this.data.shoes,
                            order_shoesQty: this.data.shoesQty,
                            order_coatSize: this.data.coat[0].size,
                            order_coatSize2: this.data.coat[0].size ? this.data.coat[0].size : '',
                            order_coatQty: this.data.coat[0].cantidad,
                            order_coatQty2: this.data.coat[1].cantidad ? this.data.coat[1].cantidad : '',
                            scrub_model: this.data.modelScrub,
                            pats_model: this.data.modelPants,
                            overol_model: this.data.modelOverol,
                            shoes_model: this.data.modelShoes,
                            scrubCap_model: this.data.modelScrubCap,
                            coat_model: this.data.modelCoat[0],
                            coat_model2: this.data.modelCoat[1] ? this.data.modelCoat[1] : '',
                            position_name: this.data.jobPosition,
                            order_scrubCapSize: this.data.scrubCap,
                            order_scrubCapQty: this.data.scrubCapQty,
                        })
                    )
                    .then((response) => {
                        this.loading = true
                        console.log(response)
                        if (!response.data.error.code && response.data.order) {
                            const orderId = response.data.order.id

                            // descargar pdf
                            this.downloadPDF(orderId)

                            

                            sessionStorage.removeItem('dataUser')
                            sessionStorage.setItem('dataOrder',JSON.stringify(response.data.order))
                            this.$router.push({ name: 'ConfirmationOrder', params: { data: response.data.order}})
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                } else {
                    this.loading = false
                }
            }
        }
    }
</script>

<style scoped>
.details-order{
    padding: 70px 15%;
}
h3{
    font-weight: bold;
    font-size: 25px;
}
span{
    font-size: 16px;
    color: #5965B1;
}
p{
   font-size: 20px; 
}
.note{
    font-size: 14px;
    color: #5965B1;
}
.btn,
.btn:focus,
.btn:hover{
    background: #F15E1A;
    border: none;
    width: 100%;
}
.icon{
    margin-top: -5px;
}
.btn-back{
    position: absolute;
    left: 10%;
    text-decoration: none;
    color: #5965B1;
    border: 1px solid #5965B1;
    width: fit-content;
    padding: 5px 20px;
    border-radius: 5px;
}
@media (max-width: 1600px) {
    .details-order{
        padding: 50px 15%;
    }
    .details-order .container{
        padding: 0 11%;
    }
    h3{
        font-size: 18px;
    }
    span{
        font-size: 12px;
    }
    p{
        font-size: 15px; 
    }
    .note{
        font-size: 11px;
    }
    .icon{
        width: 20px;
        margin-right: 5px;
    }
}
@media (max-width: 768px) {
    .details-order{
        padding: 50px 5% 50px 5%
    }
    .btn-back{
        position: relative;
        left: 0;
        margin-bottom: 20px;
    }
}
</style>